import React, { ReactNode, useEffect, useRef } from "react";
import { IconSVG } from "../../../../../shared/custom/icon/IconSVG";
import configuration from "../../../../../shared/configuration";

export const SubNavbar = ({
                            children,
                            isExpand = false,
                            showExpand = true,
                            setIsExpand
                          }: { children: ReactNode, isExpand?: boolean, showExpand?: boolean, setIsExpand?: (isExpand: boolean) => void, }) => {
  const subNavbarRef = useRef<HTMLDivElement>(null);

  const toggleExpand = () => setIsExpand && setIsExpand(!isExpand);

  useEffect(() => {
    if (!isExpand || !setIsExpand) {
      return;
    }

    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as Node;
      const subNavbarEl = subNavbarRef.current;

      if (!subNavbarEl || subNavbarEl.contains(target)) {
        return;
      }

      const rootNav = subNavbarEl.closest("nav.sh.navbar");
      if (rootNav && event.clientY <= rootNav.getBoundingClientRect().bottom) {
        return;
      }

      setIsExpand(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isExpand, setIsExpand]);

  return (
    <div className="container-fluid sub-navbar" ref={subNavbarRef}>
      {children}
      {showExpand && (
        <button
          className={`icon-expand ${isExpand ? "is-expanded" : ""}`}
          type="button"
          aria-label={isExpand ? "Comprimi anagrafica paziente" : "Espandi anagrafica paziente"}
          onClick={toggleExpand}
        >
          <IconSVG
            tintColor={configuration.theme.primary}
            icon={"chevron-down"}
            size={"16px"}
            withoutWrapper
          />
        </button>
      )}
    </div>
  );
};
